import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

import { withViewer } from "../../context_providers/ViewerContext";
import MenuLink from "../partials/MenuLink";

import { doProxyLogin } from "./ProxyLoginMutation";

const ProxyLoginMenuLink = props => {
  const [expanded, setExpanded] = useState(false);
  const { usersCanProxy } = props;
  const bg = "nav.95";
  const { t } = useTranslation();
  return (
    <Fragment>
      <MenuLink
        bg={bg}
        onClick={() => setExpanded(!expanded)}
        onKeyDown={event => {
          if (event.key === "Enter") {
            setExpanded(!expanded);
            event.preventDefault();
          }
        }}
      >
        {t("nav.primary.myAccount.proxyLogin")}
      </MenuLink>
      {expanded && (
        <Fragment>
          {usersCanProxy.map((user, index) => {
            return (
              <MenuLink
                key={index}
                bg={bg}
                onClick={() => doProxyLogin(user.pk)}
                onKeyDown={event => {
                  if (event.key === "Enter") {
                    doProxyLogin(user.pk);
                    event.preventDefault();
                  }
                }}
              >
                {user.userDisplay}
              </MenuLink>
            );
          })}
        </Fragment>
      )}
    </Fragment>
  );
};

export default withViewer(ProxyLoginMenuLink);
